exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1tEqC8ReEuQpGl5mN4N5V6{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);
// Exports
exports.locals = {
	"view": "_1tEqC8ReEuQpGl5mN4N5V6"
};